module.exports = __webpack_public_path__ + "img/gz.64f3902c.png";